/**
 * Source copy for the Customer Story deck (IG / SV / WGP).
 * Consumed via `mockSlideText` / `mockSlideHtml`; localized variants are
 * generated through Seede together with the rest of the i18n tree.
 * `[BR]` = line break in `mockSlideHtml`.
 */
export const landingV3SlidesEn = {
  ig: {
    '01': {
      cta: 'Read Report',
      headline: 'Annual[BR]Report of[BR]the Arch.[BR]Design[BR]Firm.',
      tag: 'ANNUAL REPORT',
      url: 'www.architecturefirm.com',
    },
    '02': {
      headline: 'www.architecturefirm.com',
      tag: 'Sustainable[BR]Modern Designs',
    },
    '03': {
      body: 'Everything you need is close – schools, hubs, and green spaces.',
      cta: 'Location:',
      headline: 'What Makes A[BR]Perfect Design?',
      label: 'Design:',
      line_10: 'Sustainability:',
      line_11: 'Eco-friendly homes that care for both you and the planet.',
      subtitle: 'A neighborhood built for connection, safety, and belonging.',
      tag: '@arch_design_firm',
      text: 'Every space is created with function, light, and comfort in mind.',
      title: 'Community:',
      url: 'Our 2024 housing concept highlights four key elements of modern architecture:',
    },
    '04': {
      tag: 'Creating[BR]Comfort',
    },
    '05': {
      body: '30%',
      cta: 'Commercial[BR]architecture',
      headline: 'Project Portfolio[BR]Breakdown',
      label: 'Sustainable[BR]urban planning',
      subtitle: '15%',
      tag: '@arch_design_firm',
      title: 'Residential[BR]developments',
      url: '48%',
    },
    '06': {
      headline: 'Learn More',
      number: '2.340',
      tag: 'Total Projects',
    },
    '07': {
      headline: 'Trusted by Homeowners',
      tag: 'Rating & Reviews',
      url: 'www.architecturefirm.com',
    },
    '08': {
      cta: '65%',
      headline: 'Sales Growth',
      tag: 'Home & living',
    },
    '09': {
      headline: 'www.architecturefirm.com',
      tag: 'Your Dream[BR]Home Is Waiting.',
    },
  },
  sv: {
    '01': {
      body: '2025',
      cta: 'AUG 15-17',
      headline: 'SUNSET',
      label: 'SUMMER',
      line_10: 'ORGANIZED BY',
      line_11: 'VIBES.PROD',
      line_12: 'MAIN SPONSOR',
      line_13: 'STAR BRAND',
      line_14: 'MEDIA PARTNER',
      line_15: 'THE MUSIC TIMES',
      subtitle: 'SUNSET BEACH',
      tag: '2025 OUTDOOR[BR]MUSIC[BR]FESTIVAL',
      text: 'VIBES',
      title: '16:00H',
      url: 'MAIN STAGE[BR]BEACH CLUB',
    },
    '02': {
      body: 'MAIN STAGE • BEACH CLUB',
      cta: 'AUG 15-17',
      headline: 'MUSIC FESTIVAL',
      label: '✦',
      subtitle: '19A EDICIÓ',
      tag: '2025 OUTDOOR',
      title: 'BARCELONA',
      url: 'SUMMER[BR]VIBES',
      lineup_1: 'ALBA MORENA',
      lineup_2: 'THE MIDNIGHT',
      lineup_3: 'OCEAN DRIVE',
      lineup_4: 'SOLAR FLARE',
      lineup_5: 'NEON WAVES',
    },
    '03': {
      cta: 'JOIN US AT SUNSET BEACH',
      headline: 'SUMMER[BR]VIBES',
      tag: 'THE BIGGEST EVENT OF THE YEAR',
      url: 'AUG 15-17 • SUNSET BEACH',
    },
    '04': {
      cta: 'AUG 15-17 • 2025',
      headline: 'SUMMER VIBES FESTIVAL 2025',
      tag: 'OFFICIAL INVITATION',
      title: '✦',
      url: 'SUMMER[BR]VIBES',
    },
  },
  wgp: {
    '01': {
      body: 'Month Year',
      cta: 'Subheadline',
      headline: 'Week of Nov 11–17[BR]Focus: Cedar Night + gifting bundles',
      tag: 'WEEKLY GROWTH PULSE',
      url: 'Prepared by Mia (Growth & Ops)',
    },
    '02': {
      body: 'Orders 2,352[BR]+6.2% WoW',
      cta: 'Sessions 156,900[BR]+10.3% WoW',
      tag: 'What moved this week',
    },
    '03': {
      headline:
        "Our top-line grew, but performance marketing got more expensive. Email carried efficiency while Paid Social under-delivered. Next week we'll rebalance spend, improve checkout clarity, and scale winning email flows.",
      tag: 'Cedar Night · Featured Scent[BR]Warm cedar · amber · clean smoke',
    },
    '04': {
      body: 'Shifted creative toward “Cedar Night” hooks and gifting angles.',
      cta: 'Expanded Paid Social prospecting to increase reach and new sessions.',
      headline: 'First thing',
      label: 'Improved email sends and offer framing; saw stronger purchase intent.',
      line_10: 'Topic',
      subtitle: 'Fourth thing',
      tag: 'What we did this week',
      text: 'Noticed checkout-start softness; flagged for friction review (shipping &amp; payment).',
      title: 'Third thing',
      url: 'Second thing',
    },
    '05': {
      aov_label: 'AOV (WoW -1.0%)',
      orders_label: 'Orders (WoW +6.2%)',
      revenue_label: 'Total revenue (WoW +5.1%)',
      roas_label: 'Paid ROAS (WoW -9.4%)',
      sessions_label: 'Sessions (WoW +10.3%)',
      tag: 'Traffic grew faster than revenue as paid efficiency softened.',
    },
    '06': {
      tag: "Cedar Night is our strongest story this week. We'll push it across Paid + Email with clearer benefit-first framing.",
    },
    '07': {
      headline:
        'Paid Social expanded reach this week, lifting total sessions. But incremental traffic was lower-intent, pulling conversion down. With spend rising, blended CAC increased and paid ROAS declined.',
      tag: 'Why it happened',
      url: 'Email was the bright spot: stronger intent and better offer framing drove more orders per visit. Funnel signals suggest checkout friction—checkout starts dipped despite higher product views—worth investigating before scaling spend further.',
    },
    '08': {
      cta: 'Review payment failure rate &amp; decline reasons[BR]A/B test shipping threshold messaging[BR]Increase express pay visibility (Shop Pay / Apple Pay)[BR]Add post-purchase upsell for refill packs',
      headline: 'One-week performance snapshot · This week vs last week',
      tag: 'Next week plan',
      url: 'Reduce spend on low-ROAS ad sets[BR]Launch 3 new Cedar Night creatives (benefit-first hooks)[BR]Add gifting bundle emphasis to top ads[BR]Align landing hero to scent + outcome in one line',
    },
    '09': {
      headline:
        'Bloom&amp;Co Weekly Pulse · Nov 11–17[BR]Data: Shopify + GA4 + Meta Ads[BR]Owner: Mia (Growth &amp; Ops)',
      tag: 'Next update: clearer conversion, lower CAC.',
      url: 'Primary focus: Paid Social efficiency + Checkout clarity + Email automations',
    },
  },
};
